// extracted by mini-css-extract-plugin
export default {"cards":"TraitScoreCards-module__cards__DA9iB","card":"TraitScoreCards-module__card__U5cPz"};